import { AbstractControl, FormGroup } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModelField } from '@app/shared/interfaces/front-end-column';
import { MediaStructure } from '@app/shared/interfaces/MediaStructure';

@Component({
  selector: 'app-product-field',
  templateUrl: './product-field.component.html',
  styleUrls: ['./product-field.component.less'],
})
export class ProductFieldComponent implements OnInit {

  @Input() field: ModelField;
  @Input() dropDownsMetaData: { [key: string]: any };
  @Input() formGroup: FormGroup;
  @Input() value: any = null;
  @Input() objectTypeId = 0;
  @Input() languageId = 0;
  @Input() enableCreateOption: boolean = false;
  private _record: any;
  public get record(): any {
    return this._record;
  }
  @Input() public set record(value: any) {
    this._record = value;
  }
  @Input() disabled: boolean = false;
  @Input() controlName: string = '';
  @Output() onBlur = new EventEmitter<{ key: string; value: any }>();
  fileList: MediaStructure[] = [];
  youtubeAPIKey = 'AIzaSyDliwVbYGfP9qkDjLPGMjvtL_Tz6m5hCHo';
  image: MediaStructure[] = [];

  constructor() {}

  ngOnInit() {
}


  markFormGroupDirty() {
    this.formGroup.markAsDirty();
  }

  onFieldValueChange(value: any) {
    
    //console.log('onFieldValueChange', { key: this.field.Code.toString(), value: value });
    //this.onBlur.emit({ key: this.field.Code.toString(), value: value });
  }

  get control() {
    return this.formGroup.get(this.field.Code.toString());
  }
}




